var _g, _g2, _g3, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 763,
    height: 763,
    viewBox: "0 0 763 763",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_544_441)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 381.5,
    cy: 377.5,
    r: 281.5,
    fill: "#F3F3F3"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_544_441)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 381.673,
    cy: 377.673,
    r: 235.916,
    fill: "#F3F3F3"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_544_441)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 381.968,
    cy: 377.968,
    r: 188.466,
    fill: "#F3F3F3"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M442.948 322.736L434.404 307.904C427.189 295.38 409.151 295.38 401.937 307.904L385.125 337.085L435.954 425.312H469.576C484.006 425.312 493.025 409.657 485.81 397.134L465.685 362.201C464.24 362.468 462.739 362.608 461.189 362.608C442.664 362.608 431.085 342.511 440.348 326.433C441.123 325.088 441.995 323.856 442.948 322.736ZM453.313 315.68L445.226 301.642C433.201 280.77 403.139 280.77 391.114 301.642L377.122 325.929C363.03 312.726 339.022 314.915 328.631 332.95L297.925 386.25C287.074 380.246 272.336 383.267 265.396 395.312C258.322 407.592 263.404 422.215 274.452 428.439C268.234 447.917 282.589 469.143 304.281 469.143H422.335C438.69 469.143 449.238 452.347 442.988 437.835H469.576C493.626 437.835 508.657 411.744 496.632 390.872L476.964 356.733C485.138 349.576 488.185 337.117 482.03 326.433C475.875 315.749 463.585 312.165 453.313 315.68ZM304.281 456.62C291.001 456.62 282.304 443.36 286.627 431.485C304.906 431.206 316.253 411.318 307.106 395.361L339.454 339.212C346.079 327.712 362.485 326.865 370.586 337.275L339.708 390.872C327.683 411.744 342.714 437.835 366.764 437.835H428.738L430.948 441.671C434.776 448.315 429.991 456.62 422.335 456.62H304.281ZM421.524 425.312H366.764C352.334 425.312 343.316 409.657 350.53 397.134L377.911 349.608L421.524 425.312Z",
    fill: "url(#paint0_radial_544_441)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_544_441",
    x: 0,
    y: 0,
    width: 763,
    height: 763,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_544_441"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_544_441",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_544_441",
    x: 125.756,
    y: 125.756,
    width: 511.833,
    height: 511.832,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_544_441"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_544_441",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_544_441",
    x: 173.502,
    y: 173.502,
    width: 416.933,
    height: 416.933,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_544_441"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_544_441",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_544_441",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(501.178 227.565) rotate(132.542) scale(404.336 304.77)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#15E3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.537913,
    stopColor: "#C05EFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE950"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.00024ab94fdaf13941e302ab08ab35ae.svg";
export { ForwardRef as ReactComponent };